import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useProfile } from 'core/hooks/auth/useProfile';
import { AppTester } from 'supporting';

const useCanonical = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTagPage = !!useRouteMatch('/tag');
  const isMainPage = !!useRouteMatch('/');
  const profile = useProfile();

  const canonicalUrl = useMemo(() => {
    const domain = window.location.origin;
    const currentUrl = window.location.href;

    if (isMainPage && !profile) {
      return domain;
    }

    return null;
  }, [isMainPage, profile]);

  return canonicalUrl;
};

export default useCanonical;
import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useProfile } from 'core/hooks/auth/useProfile';
import { AppTester } from 'supporting';

const useCanonical = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTagPage = !!useRouteMatch('/tag');
  const isMainPage = !!useRouteMatch('/');
  const profile = useProfile();

  const canonicalUrl = useMemo(() => {
    const domain = window.location.origin;
    const currentUrl = window.location.href;

    if (isMainPage && !profile) {
      return domain;
    }

    return null;
  }, [isMainPage, profile]);

  return canonicalUrl;
};

export default useCanonical;
